import axios from 'axios'

/**
 * authLogin 用户登录
 * queryUserMenuList 查询侧边栏
 * queryButtonPermission 查询用户可见按钮
 */

// 客服登录
export function authLogin (datas) {
  const url = `/customerLogin/login`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 查询侧边栏
export function queryMenuList (datas) {
  const url = `/customerLogin/queryMenuList`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 查询用户可见按钮
export function queryButtonPermission (datas) {
  const url = `/customerLogin/queryButtonPermission`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 根据二级域名获取一级平台信息
export function queryPlatformInfoByDomain (datas) {
  const url = '/customerPlatform/queryPlatformInfoByDomain'
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/public/auth.js